import {
  pollInterval,
  useAppQuery,
  useCurrentSubscriptionId,
} from "@phonero/common-ux"
import { MyVippsRecurringDocument, OrderDetailFragment } from "./PaymentCallback.generated"
import {
  AgreementStatus,
} from "@phonero/common-graphql/types"
import { useEffect } from "react"
import { uncompletedPurchases } from "../../../util/reactiveVars"

export const useRecurringPaymentDetailPoller = (paymentID?: string) => {
  // NOTE: becuase of a race-condition with the cache, this might return data for the wrong items.
  /// Apollo is being really naughty here...
  const { subscriptionId } = useCurrentSubscriptionId()
  console.log("useRecurringPaymentDetailPoller", paymentID, subscriptionId)

  // nosemgrep: semgrep.gql-missing-error-check-warning
  const paymentDetail = useAppQuery(MyVippsRecurringDocument, {
    onCompleted: (d) => {
      if (!d.myOrders?.nodes?.length) {
        return
      }
      const order = d.myOrders?.nodes![0]
      if (order?.vippsAgreementDetails?.status === AgreementStatus.Active) {
        paymentDetail.stopPolling()
      }
    },
    pollInterval: pollInterval(1000),
    skip: !paymentID || !subscriptionId,
    variables: {
      paymentID: paymentID!,
    },
  })

  const order: OrderDetailFragment | undefined = paymentDetail?.data?.myOrders?.nodes![0] ?? undefined
  const vippsPaymentStatus = order?.vippsAgreementDetails?.status

  useEffect(() => {
    if (!paymentID) return
    // The purpose of this effect is to automatically mark the stored uncompletedPurchases as completed (which will remove them)
    // for cases where we know the user does not need to perform any action on them.
    switch (vippsPaymentStatus) {
      case AgreementStatus.Active:
      case AgreementStatus.Stopped:
      case AgreementStatus.Expired:
        uncompletedPurchases.remove(paymentID)
        return
    }
    if (!vippsPaymentStatus) {
      return
    }
  }, [
    paymentID,
    vippsPaymentStatus
  ])

  if (!paymentID) {
    return undefined
  }

  return {
    lastState: undefined,
    states: [],
    order,
    paymentDetail,
    loading: paymentDetail.loading
  }
}
